import React, { PureComponent, Fragment } from "react";
import {
    SearchState,
    SortingState,
    SelectionState,
    PagingState,
    CustomPaging,
    FilteringState
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table as Table2,
    TableHeaderRow,
    TableFilterRow,
    TableSelection,
    PagingPanel,
    Toolbar as Toolbar2,
    SearchPanel,
    TableColumnVisibility,
    DragDropProvider,
    TableColumnReordering
} from '@devexpress/dx-react-grid-material-ui';
import debounce from 'lodash/debounce';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import { withRouter } from "react-router";
import TableCell from './table-cell/TableCell';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from '../common/EndpointsGetter';
import { columns, pageSizes, tableColumnFiltering } from './user-management-util';
import SelectFilterCell from './filter-cell/FilterCell';
import CustomPagingPanel from '../common/data-table/CustomPagingPanel';

class UserManagementTable extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            pageSize: 10,
            filters: [],
            searchValue: '',
            hiddenColumnNames: [],
            tableColumnVisibility: [
                { columnName: 'name', togglingEnabled: false }
            ],
            selection: [],
            sorting: [],
            rows: [],
            selectedRole: '',
            columnOrder: ['username', 'name', 'lastLoginTs', 'status', 'userRole', 'actions']
        };
        this.delayLoadData = debounce(this.delayLoadData, 650);
    }

    currentPageChange = (currentPage) => {
        let selection = [];
        this.setState({ currentPage, selection }, () => {
            this.loadData(currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
        });
    }

    changePageSize = (pageSize) => {
        let selection = [];
        this.setState({ pageSize, selection }, () => {
            this.loadData(this.state.currentPage, pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
        });
    }

    changeSearchValue = value => {
        this.setState({ searchValue: value });
        this.delayLoadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, value);
    }

    hiddenColumnNamesChange = hiddenColumnNames => {
        this.setState({ hiddenColumnNames });
    }

    changeFilters = (filters) => {
        let selection = [];
        this.setState({ filters, selection, currentPage: 0 }, () => {
            this.delayLoadData(this.state.currentPage, this.state.pageSize, filters, this.state.sorting, this.state.searchValue);
        });
    }

    changeSorting = sorting => {
        this.setState({ sorting });
        this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, sorting, this.state.searchValue);
    };

    changeCurrentPage = currentPage => {
        let selection = [];
        this.setState({ currentPage, selection }, () => {
            this.loadData(currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
        });
    };

    changeColumnOrder = (newOrder) => this.setState({ columnOrder: newOrder });

    roleChange = (event, row) => {
        let body = {
            name: row.name,
            userName: row.username,
            userRole: event.target.value,
        };
        let accessToken = localStorage.getItem('access_token');
        this.props.toggleLoader(true);

        axiosInstance.put(`${EndpointsGetter.getUserUpdateByIdEndpoint()}/${row.id}`, body, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                this.props.showMessage(`You've changed ${row.username}'s role.`);
            })
            .catch(error => {
                this.props.errorCallback(error);
                this.props.toggleLoader(false);
            });
    };

    loadData = (currentPage, pageSize, filters, sorting, searchValue) => {
        let filterObject = {};
        let sortObject = {};
        if (sorting.length > 0) {
            if (sorting[0].columnName == "lastLoginTs") {
                sortObject['lastLoginTs'] = sorting[0].direction.toUpperCase();
            } else {
                sortObject[sorting[0].columnName] = sorting[0].direction.toUpperCase();
            }
        } else {
            sortObject["name"] = "ASC";
        }
        if (filters.length > 0) {
            for (let filter of filters) {
                filterObject[filter.columnName] = filter.value;
            }
        }
        if (searchValue != '') {
            filterObject['keyword'] = searchValue;
        }

        this.props.getAllUsersCallback({
            pageSize: pageSize,
            pageNumber: currentPage + 1,
            sort: sortObject,
            filters: filterObject
        });
    };

    toggleActivity = (user, action) => {
        let accessToken = localStorage.getItem('access_token');
        this.props.toggleLoader(true);

        axiosInstance.put(`${EndpointsGetter.getChangeUserStatusEndpoint()}/${user.id}?status=${action}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + accessToken
            }
        })
            .then(response => {
                this.loadData(this.state.currentPage, this.state.pageSize, this.state.filters, this.state.sorting, this.state.searchValue);
                this.props.showMessage(`You've changed ${user.username}'s status to ${action}.`);
            })
            .catch(error => {
                this.props.errorCallback(error);
                this.props.toggleLoader(false);
            })
    }

    resendInvitation = (row) => {
        this.props.toggleLoader(true);
        let resendReq = {
            "username": row.username,
            "invitationMessage": "Invitation resend."
        },
            accessToken = localStorage.getItem("access_token");

        axiosInstance.post(EndpointsGetter.getResendInvitationEndpoint(), resendReq, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        })
            .then(response => {
                this.props.toggleLoader(false);
                this.props.showMessage(`You've successfully resend the invitation.`);
            })
            .catch(error => {
                this.props.errorCallback(error);
                this.props.toggleLoader(false);
            })
    }

    confirmAction = (action, row, value) => {
        this.props.openConfirmationDialog(this.generateConfirmDialogProps(action, row, value));
    }

    delayLoadData = (currentPage, pageSize, filters, sorting, searchValue) => {
        let trimmedFilters = filters.map(filter => { return { ...filter, value: filter.value.trim() } });
        this.setState({ filters: trimmedFilters, searchValue: searchValue.trim() });
        this.loadData(currentPage, pageSize, trimmedFilters, sorting, searchValue.trim());
    }

    generateConfirmDialogProps = (action, row, value) => {
        let message = '',
            confirmFunction;
        switch (action) {
            case 'roleChange':
                message = `Are you sure you want to change ${row.username}'s role from ${row.userRole} to ${value.target.value}?`;
                confirmFunction = this.roleChange.bind(null, value, row);
                break;
            case 'statusChange':
                message = `Are you sure you want to change ${row.username}'s status from ${row.status} to ${value}?`;
                confirmFunction = this.toggleActivity.bind(null, row, value);
                break;
            case 'resendInvitation':
                message = `Are you sure you want to resend ${row.username}'s invitation?`;
                confirmFunction = this.resendInvitation.bind(null, row);
                break;
            default:
                message = 'Are you sure you want to complete this action?';
                break;
        }

        return {
            message: message,
            handleConfirm: confirmFunction,
        };
    }

    renderFilterCell = (props) => {
        const { column } = props,
            { user } = this.props;

        if (column.name === 'userRole') return <SelectFilterCell {...props} user={user} />;
        return <TableFilterRow.Cell {...props} />;
    }

    render() {
        let { userData, user } = this.props,
            { currentPage, pageSize, searchValue, hiddenColumnNames, tableColumnVisibility, filters, columnOrder } = this.state;

        return (
            <Grid
                rows={userData.elements}
                columns={columns}
            >
                <SearchState
                    value={searchValue}
                    onValueChange={this.changeSearchValue}
                />
                <SelectionState />
                <FilteringState
                    filters={filters}
                    onFiltersChange={this.changeFilters}
                    columnExtensions={tableColumnFiltering}
                />
                <PagingState
                    currentPage={currentPage}
                    pageSize={pageSize}
                    onCurrentPageChange={this.changeCurrentPage}
                    onPageSizeChange={this.changePageSize}
                />
                <CustomPaging
                    totalCount={userData.totalElements}
                />
                <SortingState
                    defaultSorting={[{ columnName: 'name', direction: 'asc' }]}
                    onSortingChange={this.changeSorting}
                    columnExtensions={[
                        { columnName: 'actions', sortingEnabled: false }
                    ]}
                />
                <DragDropProvider />
                <Table2
                    columnExtensions={[]}
                    cellComponent={(props) => <TableCell
                        {...props}
                        confirmAction={this.confirmAction}
                        changeRole={this.roleChange}
                        toggleActivity={this.toggleActivity}
                        resendInvitation={this.resendInvitation}
                        user={user}
                    />}
                />
                <TableColumnReordering
                    order={columnOrder}
                    onOrderChange={this.changeColumnOrder}
                />
                <TableHeaderRow showSortingControls />
                <TableColumnVisibility
                    hiddenColumnNames={hiddenColumnNames}
                    onHiddenColumnNamesChange={this.hiddenColumnNamesChange}
                    columnExtensions={tableColumnVisibility}
                />
                <Toolbar2 />
                <SearchPanel />
                <TableFilterRow
                    cellComponent={this.renderFilterCell}
                />
                <TableSelection
                    showSelectionColumn={false}
                />
                <PagingPanel
                    pageSizes={pageSizes}
                    containerComponent={() => <CustomPagingPanel
                        pageSizes={pageSizes}
                        pageSize={pageSize}
                        onChangePageSize={this.changePageSize}
                        currentPage={currentPage}
                        totalCount={userData.totalElements}
                        onCurrentPageChange={this.changeCurrentPage}
                    />}
                />
            </Grid>
        )
    }
}

const CustomCell = ({ value, style, ...restProps }) => {
    return (
        <Table2.Cell
            {...restProps}
            style={{
                backgroundColor: value < 5000 ? 'red' : undefined,
                ...style,
            }}
        >
            <span style={{ color: value < 5000 ? 'white' : undefined }}>
                {value}
            </span>
        </Table2.Cell>
    )
}

let RoleFilterInput = props => {
    const { onRoleChange, selectedRole } = props;
    let value = selectedRole ? selectedRole : 'placeholder';

    return (
        <Select
            value={value}
            onChange={onRoleChange}
            inputProps={{
                name: 'filterByRole',
                id: 'filterByRole',
            }}
            style={{ minWidth: '140px' }}
        >
            <MenuItem value={"placeholder"}>Any role</MenuItem>
            <MenuItem value={'ROLE_ADMIN'}>Admin</MenuItem>
            <MenuItem value={'ROLE_EDITOR'}>Editor</MenuItem>
            <MenuItem value={'ROLE_VIEWER'}>Viewer</MenuItem>
        </Select>
    );
};

UserManagementTable.propTypes = {
    userData: PropTypes.object,
    getAllUsersCallback: PropTypes.func,
    errorCallback: PropTypes.func,
    toggleLoader: PropTypes.func,
    openConfirmationDialog: PropTypes.func,
    showMessage: PropTypes.func,
    user: PropTypes.object
}

export default withRouter(UserManagementTable);


// WEBPACK FOOTER //
// ./src/main/content/user-management/UserManagementTable.js